import { Card, Flex, Text, Box, Badge } from '@radix-ui/themes'
import { ArrowRight, Zap } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { TransferStatusBadge } from './TransferStatusBadge'

import { Transfer, TransferType } from '@/interfaces/Transfer'
import { AppPath } from '@/enums/AppPath'

interface TransferCardProps {
  transfer: Transfer
}

const formatCLP = (amount: number): string => {
  return `$${amount.toLocaleString('es-CL')}`
}

export const TransferCard = ({ transfer }: TransferCardProps) => {
  const navigate = useNavigate()
  const date = new Date(transfer.createdAt)

  return (
    <Card
      className="cursor-pointer hover:shadow-md transition-shadow"
      onClick={() => navigate(`/${AppPath.Transfers}/view/${transfer._id}`)}
    >
      <Flex justify="between" align="center" gap="4" p="2">
        <Flex direction="column" gap="1" style={{ flex: 1 }}>
          <Flex gap="2" align="center">
            <Text size="3" weight="bold">
              #{transfer.number}
            </Text>
            <TransferStatusBadge status={transfer.status} />
            {transfer.type === TransferType.EXPRESS && (
              <Badge color="teal" variant="soft" size="1">
                <Zap className="w-2 h-2 mr-1" />
                Express
              </Badge>
            )}
          </Flex>
          <Flex gap="2" align="center">
            <Text size="2" weight="medium">
              {transfer.vehicleData.plate}
            </Text>
            <Text size="2" color="gray">
              {transfer.vehicleData.brand} {transfer.vehicleData.model} {transfer.vehicleData.year}
            </Text>
          </Flex>
          <Flex gap="2" align="center">
            <Text size="1" color="gray">
              Comprador: {transfer.buyer.name}
              {transfer.compraPara?.enabled && (
                <span className="text-amber-600 font-medium ml-1">
                  (Para: {transfer.compraPara.ownerName})
                </span>
              )}
            </Text>
          </Flex>
        </Flex>

        <Flex direction="column" align="end" gap="1">
          <Text size="2" weight="medium">
            {formatCLP(transfer.totalCost)}
          </Text>
          <Text size="1" color="gray">
            {date.toLocaleDateString('es-CL')}
          </Text>
        </Flex>

        <Box className="text-gray-400">
          <ArrowRight className="w-4 h-4" />
        </Box>
      </Flex>
    </Card>
  )
}
